export const title = 'Vendas (Gráfico)';
import CampaignAttributionDateNote from '../../shared/partials/campaign-attribution-date-note.pt.mdx';

Gráfico da quantidade de vendas atribuídas a campanhas ao longo do tempo.

<CampaignAttributionDateNote />
